import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { IssueEntity } from './issue.entity';

@Index('UK_issue_link', ['fkIssueId', 'entityType', 'entityId'], {
	unique: true,
})
@Index('idx_issue_link_entity', ['entityType', 'entityId'], {})
@Entity('issue_link')
export class IssueLinkEntity extends BaseEntity {
	@Column('int', { name: '_fk_issue__id', unsigned: true })
	public fkIssueId!: number;

	@Column('varchar', { name: 'entity_type', length: 50 })
	public entityType!: string;

	@Column('int', { name: 'entity_id', unsigned: true })
	public entityId!: number;

	@ManyToOne(() => IssueEntity, (issue) => issue.issueLinks, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_issue__id', referencedColumnName: 'id' }])
	public fkIssue!: IssueEntity;
}
